import { HookOutOfContextError } from "@jugl-web/utils";
import { createContext, useContext } from "react";

export interface LiveChatUIContextValue {
  isSidebarOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
}

export const LiveChatUIContext = createContext<LiveChatUIContextValue | null>(
  null
);

export const useLiveChatUIContext = (): LiveChatUIContextValue => {
  const context = useContext(LiveChatUIContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useLiveChatUIContext",
      "LiveChatUIContext"
    );
  }

  return context;
};
